<template>
  <global-modal name="event-modal-documents-acts">
    <Modal @close="$modal.hide('event-modal-documents-acts')">
      <EventDocumentsPopup tab="acts" />
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import EventDocumentsPopup from "./EventDocumentsPopup.vue";

export default {
  name: "EventModalDocumentsActs",
  components: {
    Modal,
    EventDocumentsPopup
  }
};
</script>
